import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

// Attaches X-User-ID (the logged employee id) to the backends that use it as the acting user —
// createdBy / movement actor / approver identity. Scoped by URL so it never adds a header another
// backend's CORS would reject.
//   - asset-service:  any /api/v1/.../assets call
//   - letter-svc:     every call (its CORS allows X-User-ID); it drives createdBy/updatedBy and
//                     the "you cannot decide your own letter request" rule.
//   - compensation-svc: every call; it records the actor on each row from this header.
//   - leave-service:  every call (CORS allows any header); the delete endpoints take their
//                     audit actor from it only.
//
// To add a service that reads X-User-ID, put its base URL in USER_ID_BASE_URLS.
const USER_ID_BASE_URLS = [environment.letterBaseUrl, environment.compensationBaseUrl, environment.leaveBaseUrl];

const wantsUserId = (url: string): boolean =>
  USER_ID_BASE_URLS.some((base) => !!base && url.startsWith(base));

export const userIdInterceptor: HttpInterceptorFn = (req, next) => {
  const isAssetApi = req.url.includes('/api/v1/') && req.url.includes('/assets');
  if (!isAssetApi && !wantsUserId(req.url)) {
    return next(req);
  }
  const userId = inject(AuthService).loggedEmployeeId();
  if (!userId) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'X-User-ID': String(userId) } }));
};
